import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44f149db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sales-article__content" }
const _hoisted_2 = { class: "sales-article__header-wrapper" }
const _hoisted_3 = { class: "sales-article__header" }
const _hoisted_4 = { class: "sales-article__category" }
const _hoisted_5 = {
  key: 0,
  class: "sales-article__group-warning"
}
const _hoisted_6 = { class: "sales-article__footer" }

import { ALERT_TYPES, FORMATS, SIZES } from '@/enums/components'
import { servicePublicDetailsCommonProps } from '@/enums/public'
import { PropType, ref } from 'vue'
import ServiceView from '@/views/public/ServiceView.vue'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import RequiredAsterisk from '@/components/misc/RequiredAsterisk.vue'
import { areNewServiceCategoriesEnabled } from '../../utils/services'
import { ServiceType } from '../../enums/services'
import AlertBanner from '@/components/AlertBanner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceItemCard',
  props: {
  service: servicePublicDetailsCommonProps.service,
  referral: servicePublicDetailsCommonProps.referral,
  grouped: Boolean,
  available: {
    type: Boolean as PropType<boolean | undefined>,
    default: undefined,
  },
  required: Boolean,
},
  emits: ["openDetails"],
  setup(__props) {

const props = __props

/**
 * Common visual component for different types of services.
 * Initial use is in group type service view to list sales articles under it
 */





const isDetailsOpen = ref<boolean>(false)

const onOpenDetails = () => {
  isDetailsOpen.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_TranslatedContent = _resolveComponent("TranslatedContent")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_InfoHelper = _resolveComponent("InfoHelper")!
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sales-article", {
      'sales-article--grouped': __props.grouped,
      'sales-article--available': __props.available === true,
      'sales-article--unavailable': __props.available === false,
    }])
  }, [
    (__props.service.gallery)
      ? (_openBlock(), _createBlock(PhotoGallery, {
          key: 0,
          photos: __props.service.gallery,
          "show-header-only": true,
          "hide-header-only-interface": true,
          "is-show-photo-gallery": true,
          class: "sales-article__gallery"
        }, null, 8, ["photos"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, [
            _createVNode(_component_TranslatedContent, {
              class: "sales-article__title",
              value: __props.service.name
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(areNewServiceCategoriesEnabled)
                ? __props.service.vat_category.name
                : __props.service.category.name), 1)
        ]),
        (__props.service.type === _unref(ServiceType).GROUP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(AlertBanner, {
                "alert-type": _unref(ALERT_TYPES).INFO,
                text: 
              _ctx.$t('groupView.info.wrongQuantity', {
                minAmount: __props.service.min_amount || 0,
                maxAmount: __props.service.max_amount || Number.MAX_SAFE_INTEGER,
              })
            
              }, null, 8, ["alert-type", "text"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_BaseButton, {
          format: _unref(FORMATS).TERTIARY,
          size: _unref(SIZES).SMALL,
          label: _ctx.$t('relatedService.seeMore'),
          class: "sales-article__details-button",
          "icon-right": "",
          onClick: _withModifiers(onOpenDetails, ["prevent"])
        }, null, 8, ["format", "size", "label", "onClick"])
      ])
    ]),
    (__props.required)
      ? (_openBlock(), _createBlock(_component_InfoHelper, {
          key: 1,
          class: "sales-article__required"
        }, {
          activator: _withCtx(() => [
            _createVNode(RequiredAsterisk)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.$t('groupedServices.requiredLabel')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (isDetailsOpen.value)
      ? (_openBlock(), _createBlock(_component_ModalWrapper, {
          key: 2,
          title: _ctx.$t('service'),
          "modal-size": _unref(SIZES).MEDIUM,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isDetailsOpen.value = false))
        }, {
          title: _withCtx(() => [
            _createVNode(_component_TranslatedContent, {
              class: "sales-article__title",
              value: __props.service.name
            }, null, 8, ["value"])
          ]),
          content: _withCtx(() => [
            _createVNode(ServiceView, {
              "hide-ordering": "",
              "hide-title": "",
              "hide-related": "",
              "service-id": _ctx.isPreview ? __props.service.id : __props.service.hash_id,
              "is-preview": _ctx.isPreview,
              referral: __props.referral
            }, null, 8, ["service-id", "is-preview", "referral"])
          ]),
          _: 1
        }, 8, ["title", "modal-size"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})